export default __webpack_public_path__ + "static/media/door.9594b128.svg";